import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { PropertyData, QueovalDate, HtmlBase } from '../../../../models';
import { BaseAddOnComponent } from '../base-addon.component';
import { QueovalDateService } from '../../../../services';


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-boFind',
  templateUrl: './bofind.component.html',
  styleUrls: ['./bofind.component.css']
})

export class BoFindComponent extends BaseAddOnComponent implements OnInit {

  @Input('input') input: PropertyData;
  @Input('parent') parent: ElementRef;


  public qDtDebut: QueovalDate;
  public qDtFin: QueovalDate;

  constructor(private dateService: QueovalDateService) {
    super();
  }


  ngOnInit(): void {

    if (!this.input.MainElementList[0]) {
      this.input.MainElementList[0] = new HtmlBase('', '');
    }


    if (this.input.MainElementList && !this.input.MainElementList[0].Filter) {
      this.input.MainElementList[0].Value = '';
      this.input.MainElementList[0].Filter = this.input.FilterBo[0].key;
      this.input.MainElementList[0].Required = false;
    }

    if (this.input.MainElementList && (this.input.MainElementList[0].Value || this.input.MainElementList[0].Filter == 'null' || this.input.MainElementList[0].Filter == 'notnull')) {
      this.input.MainElementList[0].Required = true;
    }


    if (this.input.QueovalCode == 'DATE' ||
      this.input.QueovalCode == 'DTAGENDA' ||
      this.input.QueovalCode == 'DTQHARH' ||
      this.input.QueovalCode == 'DTHEUMIN' ) {
      if (this.input.MainElementList.length == 1) {
        this.input.MainElementList.push(JSON.parse(JSON.stringify(this.input.MainElementList[0])));
      } else {
        this.qDtFin = this.dateService.FromString(this.input.MainElementList[1].Value, 'dd/MM/yyyy');
        if (!this.input.MainElementList[1].Filter) {
          this.input.MainElementList[1].Filter = this.input.FilterBo[1].key;
        }
      }

      this.qDtDebut = this.dateService.FromString(this.input.MainElementList[0].Value, 'dd/MM/yyyy');
      if (!this.input.MainElementList[0].Filter) {
        this.input.MainElementList[0].Filter = this.input.FilterBo[0].key;
      }


      if (this.input.MainElementList && (this.input.MainElementList[1].Value || this.input.MainElementList[1].Filter == 'null' || this.input.MainElementList[1].Filter == 'notnull')) {
        this.input.MainElementList[1].Required = true;
      }
    }





  }
  public getId(item: PropertyData): string {
    return item.MainElementList && item.MainElementList.length > 0 ? item.MainElementList[0].ID : '';
  }

  public selectChange(selectedValue: string): void {
    if (this.input.MainElementList[0].SelectOptionsList.length > 0) {
      for (const item of this.input.MainElementList[0].SelectOptionsList) {
        item.Selected = item.Value === selectedValue;
        if (item.Selected) {
          this.input.MainElementList[0].Value = item.Value;
        }
      }
    } else {
      this.input.MainElementList[0].Value = selectedValue;
    }
  }

  public selectFilter(selectedValue: string, index: number = 0): void {
    this.input.MainElementList[index].Filter = selectedValue;
  }

  public DateChange(e: QueovalDate, index: number = 0) {
    this.input.MainElementList[index].Value = this.dateService.ToString(e, 'dd/MM/yyyy');
  }

  public setDate(e: HtmlBase) {
    return this.dateService.FromString(e.Value, 'dd/MM/yyyy');
  }

}


